import { useSelector } from "react-redux";
import { GraphLine } from "../../../../../../../../../../ui";

export const GraphIpssr = (props) => {
  const { result } = useSelector((state) => state.ipssm);
  return <GraphLine patientCategory={result?.IPSSR} {...props} />;
};
